export interface JwtClaims {
  sub?: string
  /** seconds since the epoch */
  exp?: number
}

/**
 * Reads the payload of a JWT. No signature check: the backend verifies every token,
 * the client only needs the subject and the expiry.
 */
export function decodeJwt(token: string): JwtClaims {
  try {
    const payload = token.split('.')[1]
    if (!payload) return {}
    const json = atob(payload.replace(/-/g, '+').replace(/_/g, '/'))
    const claims = JSON.parse(json) as Record<string, unknown>
    return {
      sub: typeof claims.sub === 'string' ? claims.sub : undefined,
      exp: typeof claims.exp === 'number' ? claims.exp : undefined,
    }
  } catch {
    return {}
  }
}
